module.exports = __webpack_public_path__ + "img/泡泡.e7fd9c81.png";